import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { ModuleRegistry } from 'react-module-container';
import { ModuleId, TModuleParams } from '@wix/business-manager-api';
import { ReactQueryCacheProvider } from 'react-query';
import { BiLoggerProvider } from '../../helpers/providers/BiLoggerProvider';
import { FontUpgrade } from 'wix-style-react';
import {
  DeleteContactContainer,
  DeleteContactContainerProps,
} from './DeleteContactContainer';

export const DeleteContactExternal = (
  props: TModuleParams & DeleteContactContainerProps,
) => {
  const { metaSiteId } = ModuleRegistry.getModule(
    ModuleId.Contacts,
  ).moduleParams;
  const experiments =
    (ModuleRegistry.getModule(ModuleId.Contacts) &&
      ModuleRegistry.getModule(ModuleId.Contacts).getExperiments()) ||
    [];

  const {
    accountLanguage,
    config: { topology },
  } = props;

  const il8nData = i18n({
    locale: accountLanguage,
    baseStaticsUrl: topology.contactsStaticsUrl,
    experiments,
  });

  const isActive = experiments['specs.crm.ContactsMadeforFont'] === 'true';

  return (
    <ReactQueryCacheProvider>
      <ExperimentsProvider options={{ experiments }}>
        <BiLoggerProvider msid={metaSiteId}>
          <I18nextProvider i18n={il8nData}>
            <FontUpgrade active={isActive}>
              <DeleteContactContainer {...props} />
            </FontUpgrade>
          </I18nextProvider>
        </BiLoggerProvider>
      </ExperimentsProvider>
    </ReactQueryCacheProvider>
  );
};

export default DeleteContactExternal;
